import service from '@/api/service/service';
import qs from "qs";


export function getEducationList(params = {}) {
  return service({
    url: '/api/education/education_list.json',
    method: 'get',
    params,
  })
}
export function educationCrateOne(data = {}) {
  return service({
    url: '/api/education/education_create_one.json',
    method: 'post',
    data: qs.stringify(data),
  })
}
export function educationInfo(params = {}) {
  return service({
    url: '/api/education/education_train_info.json',
    method: 'get',
    params,
  })
}

//获取创建培训班时暂存的已选择学员数据
export function class_student(data = {}) {
  return service({
    url: '/api/education/education_student.json',
    method: 'post',
    data:qs.stringify(data),
  })
}

// 创建继续教育时候 报名的列表
export function all_enroll_list(params = {}) {
  return service({
    url: '/api/education/all_enroll_list.json',
    method: 'get',
    params
  })
}

// /api/highTrain/to_choose_student.json    待选择学员列表
// edu_id:必传
// enroll_id:报名id
// enroll_type:报名类型
//获取创建培训班时待选择学员列表
export function to_choose_student(params = {}) {
  return service({
    url: '/api/education/to_choose_student.json',
    method: 'get',
    params,
  })
}
// status:状态
// edu_id
// student_list
//验证培训班创建时的选择学员名单
export function verify_class_student(data = {}) {
  return service({
    url: '/api/education/verify_class_student.json',
    method: 'post',
    data:qs.stringify(data),
  })
}

// 创建培训班保存学院名单
export function education_create_two(data = {}) {
  return service({
    url: '/api/education/education_create_two.json',
    method: 'post',
    data:qs.stringify(data),
  })
}

// 获取继续教育中所有学员列表 查看学员总览用到
export function getStuListByEducation(params) {
  return service({
    url: '/api/main/education_student_info_view.json',
    method: 'GET',
    params
  })
}

// 创建/编辑继续教育时候的 视频模板
export function getVideoTemplate(params) {
  return service({
    url: '/api/education/education_video_template.json',
    method: 'GET',
    params
  })
}

// 下载继续教育中学员帐号
export function loadStuAccountAjax(data = {}) {
  return service({
    url: '/api/education/student_download.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 学员查看继续教育列表
export function getEducationListToStu(params = {}) {
  return service({
    url: '/api/education/education_train_list.json',
    method: 'get',
    params,
  })
}

// 学员点击完成学习
export function submitStudyStudent(data = {}) {
  return service({
    url: '/api/education/submit_study.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 学员学习视频信息
export function studyVideoInfo(params = {}) {
  return service({
    url: '/api/education/study_video_info.json',
    method: 'get',
    params,
  })
}

// 视频看完时候的回调
export function educationVideoComplete(data = {}) {
  return service({
    url: '/api/education/education_video_complete.json',
    method: 'post',
    data: qs.stringify(data),
  })
}

// 管理员查看学员的学习详情
export function studentStudyLearnView(params = {}) {
  return service({
    url: '/api/education/student_study_learn_view.json',
    method: 'get',
    params,
  })
}
